import { render, staticRenderFns } from "./quiz.vue?vue&type=template&id=20022364&scoped=true&"
import script from "./quiz.vue?vue&type=script&lang=js&"
export * from "./quiz.vue?vue&type=script&lang=js&"
import style0 from "./quiz.vue?vue&type=style&index=0&id=20022364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20022364",
  null
  
)

export default component.exports